import React from "react";
import TempleCardHeader, { CardQr } from "./TempleCardHeader";

const Row = ({ label, children, testid }) => (
  <div className="flex gap-1">
    <span className="w-[0.72in] shrink-0 text-gold-700 font-bold uppercase text-[7.5px] tracking-wider pt-[2px]">{label}</span>
    <span className="font-semibold text-slate-900" data-testid={testid}>{children}</span>
  </div>
);

export default function SareeCard({ token, temple, templeName, templeLocation, copyLabel, portrait = false }) {
  const dmy = (d) => (d ? `${d.slice(8, 10)}/${d.slice(5, 7)}/${d.slice(0, 4)}` : "");
  if (portrait) {
    // 4 in wide x 6 in tall card (portrait card stock): header, number, photo + QR side by side, details below.
    return (
      <div className="print-area bg-white border-2 border-maroon-800 shadow-md overflow-hidden flex flex-col"
        style={{ width: "4in", height: "6in" }} data-testid="saree-card">
        <TempleCardHeader temple={temple} templeName={templeName} location={templeLocation} title="Vastra Prasadam" />
        <div className="px-3 pt-2 text-center">
          <p className="font-mono font-bold text-[14px] text-maroon-900 leading-tight" data-testid="saree-card-token">{token.token_no}</p>
          <div className="flex items-center justify-center gap-1.5 mt-1">
            <p className="text-[9px] font-bold uppercase tracking-widest text-maroon-800 border border-maroon-800 rounded px-2 py-[1px]" data-testid="saree-card-category">{token.category}</p>
            {copyLabel && <p className="text-[9px] font-bold uppercase tracking-widest text-white bg-maroon-800 rounded px-2 py-[1px]" data-testid="saree-card-copy">{copyLabel}</p>}
          </div>
        </div>
        <div className="flex items-center justify-center gap-4 px-3 pt-2">
          {token.photo ? (
            <img src={token.photo} alt="saree" className="w-[1.25in] h-[1.4in] object-cover rounded border-2 border-gold-500" data-testid="saree-card-photo" />
          ) : (
            <div className="w-[1.25in] h-[1.4in] rounded border border-dashed border-gold-500 flex items-center justify-center text-[8px] text-slate-400">SAREE PHOTO</div>
          )}
          <CardQr src={token.qr_data_url} testid="saree-card-qr" />
        </div>
        <div className="flex-1 px-4 pt-2 text-[10.5px] leading-[1.7] min-h-0">
          {token.name && <Row label="Name">{token.name}</Row>}
          <Row label="Saree Type" testid="saree-card-type">{token.saree_type_name}</Row>
          <Row label="Rate" testid="saree-card-rate"><span className="text-maroon-800">₹{token.rate}</span></Row>
          <Row label="Quantity" testid="saree-card-qty">{token.quantity || 1}</Row>
          {token.return_type && <Row label="Return Type" testid="saree-card-return"><span className={token.return_type === "Returnable" ? "text-green-700" : "text-maroon-800"}>{token.return_type}</span></Row>}
          {token.booking_date && <Row label="Booking Date">{dmy(token.booking_date)}</Row>}
          {token.phone && <Row label="Phone">{token.phone}</Row>}
          <Row label="Received">{new Date(token.created_at).toLocaleString("en-IN")}</Row>
        </div>
        <div className="bg-maroon-800 text-gold-100 px-3 py-1 text-[7.5px] leading-snug text-center">
          <p>Present this card / QR at the Godown for verification. Non-transferable.{templeLocation ? ` · ${templeLocation}` : ""}</p>
          <p className="text-gold-400 font-semibold">Aatreya Infotech Systems</p>
        </div>
      </div>
    );
  }
  return (
    <div className="print-area bg-white border-2 border-maroon-800 shadow-md overflow-hidden flex flex-col"
      style={{ width: "6in", height: "4in" }} data-testid="saree-card">
      <TempleCardHeader temple={temple} templeName={templeName} location={templeLocation} title="Vastra Prasadam" />
      <div className="flex items-center justify-between px-3 pt-1.5">
        <p className="font-mono font-bold text-[13px] text-maroon-900" data-testid="saree-card-token">{token.token_no}</p>
        <div className="flex items-center gap-1.5">
          <p className="text-[9px] font-bold uppercase tracking-widest text-maroon-800 border border-maroon-800 rounded px-2 py-[1px]" data-testid="saree-card-category">{token.category}</p>
          {copyLabel && <p className="text-[9px] font-bold uppercase tracking-widest text-white bg-maroon-800 rounded px-2 py-[1px]" data-testid="saree-card-copy">{copyLabel}</p>}
        </div>
      </div>
      <div className="flex-1 flex px-3 py-1.5 gap-3 min-h-0">
        <div className="w-[1.15in] shrink-0">
          {token.photo ? (
            <img src={token.photo} alt="saree" className="w-full h-[1.45in] object-cover rounded border-2 border-gold-500" data-testid="saree-card-photo" />
          ) : (
            <div className="w-full h-[1.45in] rounded border border-dashed border-gold-500 flex items-center justify-center text-[8px] text-slate-400">SAREE PHOTO</div>
          )}
        </div>
        <div className="flex-1 text-[10px] leading-[1.75] min-w-0">
          {token.name && <Row label="Name">{token.name}</Row>}
          <Row label="Saree Type" testid="saree-card-type">{token.saree_type_name}</Row>
          <Row label="Rate" testid="saree-card-rate"><span className="text-maroon-800">₹{token.rate}</span></Row>
          <Row label="Quantity" testid="saree-card-qty">{token.quantity || 1}</Row>
          {token.return_type && <Row label="Return Type" testid="saree-card-return"><span className={token.return_type === "Returnable" ? "text-green-700" : "text-maroon-800"}>{token.return_type}</span></Row>}
          {token.booking_date && <Row label="Booking Date">{dmy(token.booking_date)}</Row>}
          {token.phone && <Row label="Phone">{token.phone}</Row>}
          <Row label="Received">{new Date(token.created_at).toLocaleString("en-IN")}</Row>
        </div>
        <div className="shrink-0 flex items-center">
          <CardQr src={token.qr_data_url} testid="saree-card-qr" />
        </div>
      </div>
      <div className="bg-maroon-800 text-gold-100 px-3 py-1 text-[7.5px] leading-snug text-center">
        <p>Present this card / QR at the Godown for verification. Non-transferable.{templeLocation ? ` · ${templeLocation}` : ""}</p>
        <p className="text-gold-400 font-semibold">Aatreya Infotech Systems</p>
      </div>
    </div>
  );
}
